<script setup lang="ts">
import type { ClientConfigNavItem } from '@/ts/types/client-config-types';
import { getLangText } from '@/ts/utils/model-utils';
import { getFullPathOfView, navigateTo } from '@/ts/management/view-navigation-management';
import { ref, watch } from 'vue';
import model from '@/ts/model.ts';
import type { LangTextLocation } from '@/ts/types/lang-label-types.ts';

const params = defineProps<ClientConfigNavItem & {location?: LangTextLocation}>();
const fullPath = ref<string>('');

watch(() => model.lang, () => {
    fullPath.value = getFullPathOfView(params.id);
}, {immediate: true});

</script>

<template>
    <template v-if="id != 'error'">
        <a :href="fullPath" @click.prevent.stop="navigateTo(id, {userInteraction: true})">
            {{ textAsLink ? textAsLink : (label ? getLangText(label, undefined, location) : text) }}
            <slot></slot>
        </a>
    </template>
</template>